import { ID, idDef } from "@kosmod/kit"
import { GameID } from "./game";
import { s } from "@kosmod/pancake";

export type AccountID = ID<"account", true>;
export const AccountID = s.ref<AccountID>()(idDef);

export type PasswordHashID = ID<"password", true>;
export const PasswordHashID = s.ref<PasswordHashID>()(idDef);

export type SecretID = ID<'secret', true>;
export const SecretID = s.ref<SecretID>()(idDef);

export type AuthTokenID = ID<'auth-token', true>;
export const AuthTokenID = s.ref<AuthTokenID>()(idDef);

export type PasswordHash = {
  id: PasswordHashID,
  salt: string,
  hashSecret: SecretID,
}
export const PasswordHash = s.o({
  id: PasswordHashID,
  salt: s.str,
  hashSecret: SecretID
})

export type Account = {
  id: AccountID,

  username: string,
  email: string,
  
  authentication: {
    password: null | PasswordHashID,
  }
};
export const Account = s.ref<Account>()(s.o({
  id: AccountID,

  username: s.str,
  email: s.str,

  authentication: s.o({
    password: s.optional(PasswordHashID)
  })
}))
export namespace Account {
  export type ID = AccountID;
}

export type AccountDescription = {
  id: AccountID,

  username: string,
  email: string,
  
  authentication: {
    password: boolean,
  }
};
export const AccountDescription = s.ref<AccountDescription>()(s.o({
  id: AccountID,

  username: s.str,
  email: s.str,

  authentication: s.o({
    password: s.bool,
  })
}))

export type GuestPassID = ID<'guest-pass'>;
export type GuestPassDescription = {
  id: GuestPassID,
  name: string,
}

export type Secret = {
  id: SecretID,
  plain: string,
}
export const Secret = s.o({
  id: SecretID,
  plain: s.str,
})

export type AuthToken = {
  id: AuthTokenID,

  account: AccountID,
  expires: string,
  secret: SecretID,
};
export const AuthToken = s.o({
  id: AuthTokenID,

  account: AccountID,
  expires: s.str,
  secret: SecretID,
})